import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorFocusModel } from '../model/focus-selector-focus.model';
import { FocusSelectorSubBehaviourModel } from '../model/focus-selector-subbehaviour.model';

export interface FocusSelectorSelectSubBehaviourRow {
    subBehaviourId: FocusSelectorSubBehaviourModel['id'];
}

export const focusSelectorSelectSubBehaviourRow = createAction<
    ActionType,
    FocusSelectorSelectSubBehaviourRow
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_SUBBEHAVIOUR_ROW);

export interface FocusSelectorSelectFocus {
    focus: FocusSelectorFocusModel;
}

export const focusSelectorSelectFocus = createAction<
    ActionType,
    FocusSelectorSelectFocus
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_FOCUS);
